import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
    authUser: null,
    isAuth: true,
    authRegistercompanies:[]
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};